type NoiseListener = (noiseLevel: number) => void;

class VoiceEnvironmentMonitor {
  private audioContext?: AudioContext;
  private analyser?: AnalyserNode;
  private micSource?: MediaStreamAudioSourceNode;
  private rafId?: number;
  private listeners: NoiseListener[] = [];

  async startMonitoring(stream: MediaStream) {
    if (!window.AudioContext) return;
    this.audioContext = new AudioContext();
    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 256;
    this.micSource = this.audioContext.createMediaStreamSource(stream);
    this.micSource.connect(this.analyser);
    this.monitor();
  }

  stopMonitoring() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (this.audioContext) {
      this.audioContext.close().catch(() => undefined);
    }
    this.audioContext = undefined;
    this.analyser = undefined;
    this.micSource = undefined;
  }

  private monitor = () => {
    if (!this.analyser) return;
    const dataArray = new Uint8Array(this.analyser.frequencyBinCount);
    this.analyser.getByteFrequencyData(dataArray);
    const average = dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length;
    this.listeners.forEach(listener => listener(average));
    this.rafId = requestAnimationFrame(this.monitor);
  };

  addListener(listener: NoiseListener) {
    this.listeners.push(listener);
  }

  removeListener(listener: NoiseListener) {
    this.listeners = this.listeners.filter(l => l !== listener);
  }
}

export const voiceEnvironmentMonitor = new VoiceEnvironmentMonitor();
